/**
 * Centralized API URL builder — Single Source of Truth for all endpoint URLs.
 * All service files should import from here instead of constructing URLs directly.
 */

const API_BASE = import.meta.env.VITE_API_URL || '';

export const API = {
  // Auth
  csrf: `${API_BASE}/api/auth/csrf/`,
  token: `${API_BASE}/api/auth/token/`,
  login: (next: string) => `${API_BASE}/accounts/login/?next=${encodeURIComponent(next)}`,

  // Chats
  chats: `${API_BASE}/api/chats/`,
  directChats: `${API_BASE}/api/chats/?has_project=false`,
  chatMessages: (chatId: string) => `${API_BASE}/api/chats/${chatId}/messages/`,

  // Projects
  projects: `${API_BASE}/api/projects/`,
  project: (id: string) => `${API_BASE}/api/projects/${id}/`,
  projectChats: (projectId: string) => `${API_BASE}/api/projects/${projectId}/chats/`,

  // Files
  file: (fileId: string) => `${API_BASE}/api/files/${fileId}/`,

  // User
  profile: `${API_BASE}/api/profile/`,
  updateName: `${API_BASE}/api/user/update-name/`,

  // Networking
  professionals: `${API_BASE}/networking/professionals/`,
  connections: `${API_BASE}/networking/connections/`,
  groups: `${API_BASE}/networking/groups/`,

  // Education
  courses: `${API_BASE}/api/education/courses/`,
  enrollment: (courseId: string) => `${API_BASE}/api/education/courses/${courseId}/enroll/`,

  // Billing
  plans: `${API_BASE}/entitlements/api/plans/`,
  billingPortal: `${API_BASE}/api/billing-portal/`,

  // Helper: resolve a relative URL to absolute
  resolve: (path: string) => path.startsWith('http') ? path : `${API_BASE}${path}`,
} as const;
